import PreviewPatchListingProvider from './PreviewPatchListing.provider';

export default PreviewPatchListingProvider;
